'use strict';

module.exports = 0;



//////////////////
// WEBPACK FOOTER
// ./~/shortid/lib/util/cluster-worker-id-browser.js
// module id = 1088
// module chunks = 30 31 32